export default __webpack_public_path__ + "static/media/pencil.36cebc74.svg";